import React from 'react';
import { useDispatch } from 'react-redux';
import { ButtonMain } from 'components';
import { fileDownload, FindLoad, useModal } from 'utils';
import { httpRequestsOnLoadActions } from 'store';
import { Svg } from 'assets';
import axios from 'axios';

const ACTION_TYPE_EXPORT_BSON = 'ACTION_TYPE_EXPORT_BSON';

export const ExportBson = () => {
  const dispatch = useDispatch();
  const loading = FindLoad(ACTION_TYPE_EXPORT_BSON);
  const { close } = useModal();

  const handleExport = async () => {
    try {
      dispatch(httpRequestsOnLoadActions.appendLoading(ACTION_TYPE_EXPORT_BSON));
      const response = await axios.post('/export/bson', {}, {
        auth: true,
        responseType: 'blob',
        timeout: 300000,
      });
      fileDownload(response?.data, null, `caretech-export.zip`);
    } catch (e) {
      // silent
    } finally {
      dispatch(httpRequestsOnLoadActions.removeLoading(ACTION_TYPE_EXPORT_BSON));
      close();
    }
  };

  return (
    <div className="export-csv-wrapper">
      <div className="modal-header-main">
        <h2 className="modal-header-title">Database Export</h2>
        <button className="modal-close-btn-main" type="button" onClick={close}>
          <Svg.CloseSvg />
        </button>
      </div>

      <div className="modal-body-main">
        <p className='modal-header-description'>Export the entire database as a BSON archive.</p>
      </div>

      <div className="modal-footer-main">
        <ButtonMain
          text="Cancel"
          cancel
          buttonMainStyles={{ width: 'fit-content' }}
          onClick={close}
        />
        <ButtonMain
          text="Export"
          load={loading}
          onClick={handleExport}
          buttonMainStyles={{ width: '86px' }}
        />
      </div>
    </div>
  );
};
